import { Entitlements } from '../../../entitlements';
import { NavigationItem } from '../../../navigation';
import { Feature } from '../../feature-flags';

/**
 * If a property of the PwaVisibilityFeatureConditions is defined,
 * then at least one of the conditions in that property must be
 * active/true for the feature to be considered visible
 */
export interface PwaVisibilityFeatureConditions {
    isAdmin?: boolean;
    navigationKeys?: NavigationItem | NavigationItem[];
    productTypes?: ProductType | ProductType[];
    entitlements?: Entitlements | Entitlements[];
    featureFlags?: Feature | Feature[];
    widgetType?: WidgetType;
    rdcUserConfigured?: boolean;
    deviceType?: DeviceType;
    uisEnabled?: boolean;
}

export enum PwaVisibilityFeature {
    Accounts,
    AccountsWidget,
    ACH,
    AchRecipientActivity,
    AchTemplatesList,
    Admin,
    BillPay,
    Conversations,
    InfoCenterWidget,
    Loans,
    LoanWidget,
    PaymentApprovalWidget,
    PendingApprovalsAch,
    PendingApprovalsTransfers,
    PendingApprovalsWires,
    PendingApprovalsUsers,
    PendingApprovalsWidget,
    PosPayAchExceptions,
    PosPayCheckExceptions,
    PosPayWidget,
    RDC,
    ReportsWidget,
    ResourcesWidget,
    StopPaymentWidget,
    StopPayments,
    Transfers,
    TransferWidget,
    Wires,
    CheckLookupWidget,
    Reports,
    DashboardFeatureSearch,
}

export enum ProductType {
    ACH = 'ACH',
    Transfers = 'InternalTransferProduct',
    Reporting = 'InformationReportingProductFeature',
    Wires = 'WireTransferProductFeature',
    WiresFX = 'WireTransferDliProductFeature',
    PositivePay = 'ArpProductFeature',
    StopPayment = 'StopPayment',
    RDC = 'RemoteDepositCaptureSsoProductFeature',
    BillPay = 'BillPayProductFeature',
}

export enum WidgetType {
    Accounts = 'accounts',
    InfoCenter = 'infoCenter',
    Resources = 'resources',
    Reports = 'favoriteReports',
    PaymentApproval = 'paymentsPendingApproval',
    PosPay = 'arp',
    StopPayment = 'stopRequest',
    QuickTransfer = 'quickTransfer',
    QuickLoanPayment = 'quickLoanPayment',
    CheckLookup = 'checkLookup',
}

export enum DeviceType {
    DesktopOnly,
    MobileOnly,
}
